import { render, staticRenderFns } from "./Turnieranmeldung.vue?vue&type=template&id=57b36924&scoped=true&"
import script from "./Turnieranmeldung.vue?vue&type=script&lang=js&"
export * from "./Turnieranmeldung.vue?vue&type=script&lang=js&"
import style0 from "./Turnieranmeldung.vue?vue&type=style&index=0&id=57b36924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b36924",
  null
  
)

export default component.exports